import gameIframe from '@ps/bridge/iframe/iframe'
import * as mainConfigScript from '@ps/bridge/qc/scripts/main-config'
import * as mainBehScript from '@ps/bridge/qc/scripts/main-beh'

export const getMainConfigScript = (): mainConfigScript.IMainConfig | undefined => {
  if (gameIframe && gameIframe.UIRoot) {
    return mainConfigScript.getScript(gameIframe.UIRoot)
  }
}

export const getMainBehScript = () => {
  if (gameIframe && gameIframe.UIRoot) {
    return mainBehScript.getScript(gameIframe.UIRoot)
  }
}
